const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.RATINGS)

export const apiClientRatings = {
	fetchMealRatings: async (clientUuid: string, page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IClientRating[]>(`${groupPrefix}/${clientUuid}`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})
		return { data: data.map(r => ClientRating(r)), meta }
	},
}
